import { render, staticRenderFns } from "./ModulesText.vue?vue&type=template&id=37a686be"
import script from "./ModulesText.vue?vue&type=script&lang=js"
export * from "./ModulesText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicText: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicText.vue').default})
